import { z } from 'zod';
export const workOrderChargeCostSchema = z
    .number()
    .min(0, 'Cost must be a non-negative number.')
    .max(1_000_000_000, 'Cost must be 1,000,000,000 or less.');
//# sourceMappingURL=work-order-charge-cost-schema.js.map